import { Context, Config } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import { DataSources } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import { ItemDelegate } from '@leverege/molten-core';
import RemoveItems from "../view/RemoveItems.js"; // TODO: Make this go ref->Actions
const {
  t,
  tf
} = I18N.ns('molten.imagine.actions.RemoveAction');
const create = relationship => {
  const {
    blueprint,
    path,
    attribute,
    parentBlueprint
  } = relationship;
  return {
    id: `blueprint.action.${path}.RemoveItem`,
    name: tf('name', {
      blueprintName: blueprint.namePlural
    }),
    layout: {
      sort: 'item.remove2',
      sectionName: t('sectionName', {
        blueprintName: blueprint.name
      })
    },
    handles: cxt => {
      const {
        clientProps
      } = cxt;
      const rel = clientProps?.relationship;
      if (rel == null || rel.path !== path) {
        return false;
      }
      const targets = Context.getTargetsOfType(cxt, blueprint.type);
      if (targets == null || targets.length === 0) {
        return false;
      }
      let canAll = true;
      targets.forEach(tgt => {
        const delegate = DataSources.getActions(tgt);
        const can = delegate?.canDelete();
        const canDelete = delegate?.canDelete({
          deleteDevice: 'force'
        });
        if (can === false || canDelete === true && !parentBlueprint) {
          canAll = false;
        }
      });
      return canAll === true;
    },
    appearance: ({
      context,
      action
    }) => {
      const targets = Context.getTargetsOfType(context, blueprint.type);
      const num = targets.length;
      const removeFrom = parentBlueprint ? t('removeFrom', {
        blueprintName: parentBlueprint.name
      }) : '';
      return {
        name: t('appearanceName', {
          count: num,
          removeFrom,
          blueprintName: num < 2 ? blueprint.name : blueprint.namePlural
        }),
        icon: Config.get('BlueprintActions', 'removeIcon', 'https://storage.googleapis.com/molten-ui-assets/remove-action.png'),
        disabled: num === 0
      };
    },
    perform: ({
      context,
      action
    }) => {
      const {
        clientProps: {
          delegate
        }
      } = context;
      const targets = Context.getTargetsOfType(context, blueprint.type);
      if (targets.length === 0) {
        return;
      }
      Dialogs.show({
        component: RemoveItems,
        props: {
          blueprint,
          targets,
          delegate,
          attribute,
          isItem: delegate instanceof ItemDelegate
        }
      });
    }
  };
};
export default {
  create
};